import { type MaterialComponentCategory } from 'api';
import { useFieldArray, useFormContext } from 'form';
import { translate } from 'i18n';
import { Alert, Box, Button, Stack, Typography } from 'ui';
import { Add } from 'ui/icons';

import { MaterialSupportedComponent } from '../MaterialSupportedComponent/MaterialSupportedComponent';

type Props = {
  name: string;
  category?: MaterialComponentCategory;
  title?: string;
  buttonText?: string;
  materialId?: number;
  materialColourId?: number;
  disabled?: boolean;
};

export const MaterialSupportedComponentList = ({
  name,
  category,
  materialId,
  materialColourId,
  disabled,
  title = translate('backlog.materialComponents.supportedComponentList.title', { namespace: 'features' }),
  buttonText = translate('backlog.materialComponents.supportedComponentList.buttonText', { namespace: 'features' }),
}: Props) => {
  const { control, formState } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: name,
  });
  const buyerMaterialComponentError = formState.errors?.[name]?.root?.message || formState.errors?.[name]?.message;
  return (
    <Stack
      spacing={2}
      sx={{
        marginBottom: 2,
      }}
    >
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold">
          {title}
        </Typography>
        <Button
          size="medium"
          variant="secondary"
          onClick={() =>
            append({
              boolean_value: undefined,
              max_value: undefined,
              min_value: undefined,
              supported_component_id: undefined,
            })
          }
          disabled={disabled}
          startIcon={<Add />}
        >
          {buttonText}
        </Button>
      </Stack>
      {fields?.map((field, index) => (
        <Box key={`${name}-${category}-${index}`}>
          <MaterialSupportedComponent
            materialId={materialId}
            materialColourId={materialColourId}
            key={field.id}
            name={name}
            index={index}
            category={category}
            remove={remove}
            disabled={disabled}
          />
        </Box>
      ))}
      {buyerMaterialComponentError ? <Alert severity="error">{buyerMaterialComponentError.toString()}</Alert> : null}
    </Stack>
  );
};
